import React from "react";
import { Group, Path, Text } from 'react-konva';
//import { easeOutBack, easeInOutSine, easeInOutSine } from 'js-easing-functions'
import { easeOutBack, easeOutQuint, easeInOutSine } from 'js-easing-functions'
//import { easeOutBack } from 'js-easing-functions'


export default class BottomCloudsGroup extends React.Component {
  constructor(props) {
    super(props)

    this.REFERENCE_BROWSER_WIDTH = 600

    //this.ANIM_UPDATE_INTERVAL = 250
    this.ANIM_UPDATE_INTERVAL = 30

    this.TRANSITION_PAD = 750
    this.ANIM_DURATION = 3500
    this.ANIM_THRESHOLD = this.ANIM_DURATION - this.TRANSITION_PAD
    this.CLOUD_START = -200
    this.GENTLE_DURATION = 3500
    this.GENTLE_DISPLACEMENT_HALF = 25

    this.ANIM_DURATION_2 = 4000
    this.ANIM_THRESHOLD_2 = this.ANIM_DURATION_2 - this.TRANSITION_PAD
    this.CLOUD_START_2 = -200
    this.GENTLE_DURATION_2 = 4000
    this.GENTLE_DISPLACEMENT_HALF_2 = 35

    this.ANIM_DURATION_3 = 3500
    this.ANIM_THRESHOLD_3 = this.ANIM_DURATION_3 - this.TRANSITION_PAD
    this.CLOUD_START_3 = -200
    this.GENTLE_DURATION_3 = 3500
    this.GENTLE_DISPLACEMENT_HALF_3 = 25

    this.timerId = null

    this.state = {
      animationEnabled: true,
      //animationEnabled: false,
      animElapsed: 0,
      cloudx: this.CLOUD_START,
      cloudDispl: null,
      cloudy: 125,
      gentleOrigin: 0,
      gentlex: 0,
      gentleIncreasing: false,
      animPhase: 'initial',

      animElapsed2: 0,
      cloudx2: this.CLOUD_START_2,
      cloud2Displ: null,
      cloudy2: 80,
      gentleOrigin2: 0,
      gentlex2: 0,
      gentleIncreasing2: false,
      animPhase2: 'initial',

      animElapsed3: 0,
      cloudx3: this.CLOUD_START_3,
      cloud3Displ: null,
      cloudy3: 125,
      gentleOrigin3: 0,
      gentlex3: 0,
      gentleIncreasing3: false,
      animPhase3: 'initial',
    }

    this.calculateCloudDisplacements = this.calculateCloudDisplacements.bind(this)
    this.updateAnim = this.updateAnim.bind(this)
    this.updateAnim2 = this.updateAnim2.bind(this)
    this.updateAnim3 = this.updateAnim3.bind(this)

    this.initialAnimUpdate  = this.initialAnimUpdate.bind(this)
    this.initialAnimUpdate2  = this.initialAnimUpdate2.bind(this)
    this.initialAnimUpdate3  = this.initialAnimUpdate3.bind(this)

    this.gentleAnimFirstUpdate  = this.gentleAnimFirstUpdate.bind(this)
    this.gentleAnimFirstUpdate2  = this.gentleAnimFirstUpdate2.bind(this)
    this.gentleAnimFirstUpdate3  = this.gentleAnimFirstUpdate3.bind(this)

    this.gentleAnimUpdate  = this.gentleAnimUpdate.bind(this)
    this.gentleAnimUpdate2  = this.gentleAnimUpdate2.bind(this)
    this.gentleAnimUpdate3  = this.gentleAnimUpdate3.bind(this)
  }


  componentDidMount() {
    if ( this.state.animationEnabled ) {
      this.timerId = setInterval(this.updateAnim, this.ANIM_UPDATE_INTERVAL)
      this.timerId2 = setInterval(this.updateAnim2, this.ANIM_UPDATE_INTERVAL)
      this.timerId3 = setInterval(this.updateAnim3, this.ANIM_UPDATE_INTERVAL)
    }

    const [ cloudDispl, cloud2Displ, cloud3Displ ] = this.calculateCloudDisplacements()

    this.setState({
      cloudDispl, cloud2Displ, cloud3Displ
    })
  }


  calculateCloudDisplacements() {
    let cloudDispl = 250
    let cloud2Displ = 350
    let cloud3Displ = 400

    if ( window.innerWidth > 600 ) {
      const addlDispl = ( window.innerWidth - this.REFERENCE_BROWSER_WIDTH ) / 2
      cloudDispl += addlDispl
      cloud2Displ += addlDispl
      cloud3Displ += addlDispl
    }

    return [ cloudDispl, cloud2Displ, cloud3Displ ]
  }


  componentWillUnmount() {
    clearInterval(this.timerId)
    clearInterval(this.timerId2)
    clearInterval(this.timerId3)
  }


  updateAnim() {
    if ( this.state.animPhase === 'initial' ) {
      this.initialAnimUpdate()
    } else if ( this.state.animPhase === 'gentle-first' )  {
      this.gentleAnimFirstUpdate()
    } else {
      this.gentleAnimUpdate()
    }
  }

  updateAnim2() {
    if ( this.state.animPhase2 === 'initial' ) {
      this.initialAnimUpdate2()
    } else if ( this.state.animPhase2 === 'gentle-first' )  {
      this.gentleAnimFirstUpdate2()
     } else {
      this.gentleAnimUpdate2()
    }
  }

  updateAnim3() {
    if ( this.state.animPhase3 === 'initial' ) {
      this.initialAnimUpdate3()
    } else if ( this.state.animPhase3 === 'gentle-first' )  {
      this.gentleAnimFirstUpdate3()
     } else {
      this.gentleAnimUpdate3()
    }
  }


  initialAnimUpdate() {
    const newElapsed = this.state.animElapsed + this.ANIM_UPDATE_INTERVAL
    if ( newElapsed >= this.ANIM_THRESHOLD ) {
      this.setState({
        animPhase: 'gentle-first',
        animElapsed: 0,
        gentleOrigin: this.state.cloudx,
      })
    } else {
      const newx = easeOutBack(newElapsed, this.CLOUD_START, this.state.cloudDispl, this.ANIM_DURATION)
      this.setState({
        cloudx: newx,
        animElapsed: newElapsed,
      })
    }
  }


  gentleAnimFirstUpdate() {
    let newElapsed = this.state.animElapsed + this.ANIM_UPDATE_INTERVAL

    if ( newElapsed >= this.ANIM_THRESHOLD ) {
      this.setState({
        animPhase: 'gentle',
        animElapsed: 0,
        gentleOrigin: this.state.cloudx,
        gentleIncreasing: true,
      })
    } else {
      let origin = this.state.gentleOrigin
      const displacement = this.state.gentleIncreasing ? this.GENTLE_DISPLACEMENT_HALF : - this.GENTLE_DISPLACEMENT_HALF
      let gi = this.state.gentleIncreasing

      if ( newElapsed % this.GENTLE_DURATION === 0 ) {
        gi = ! this.state.gentleIncreasing
        origin = this.state.cloudx
        newElapsed = 0
      }

      const newx = easeOutQuint(newElapsed, origin, displacement, this.GENTLE_DURATION)

      this.setState({
        animElapsed: newElapsed,
        cloudx: newx,
        gentleOrigin: origin,
        gentleDest: displacement,
        gentleIncreasing: gi,
      })
    }
  }


  gentleAnimUpdate() {
    let newElapsed = this.state.animElapsed + this.ANIM_UPDATE_INTERVAL

    let origin = this.state.gentleOrigin
    const displacement = this.state.gentleIncreasing ? this.GENTLE_DISPLACEMENT_HALF : - this.GENTLE_DISPLACEMENT_HALF
    let gi = this.state.gentleIncreasing
    let fg = this.state.firstGentleAnim

    if ( newElapsed % this.GENTLE_DURATION === 0 ) {
      gi = ! this.state.gentleIncreasing
      origin = this.state.cloudx
      newElapsed = 0
      fg = false
    }

    const newx = easeInOutSine(newElapsed, origin, displacement, this.GENTLE_DURATION)

    this.setState({
      animElapsed: newElapsed,
      cloudx: newx,
      gentleOrigin: origin,
      gentleDest: displacement,
      gentleIncreasing: gi,
      firstGentleAnim: fg,
    })
  }


  initialAnimUpdate2() {
    const newElapsed = this.state.animElapsed2 + this.ANIM_UPDATE_INTERVAL
    if ( newElapsed >= this.ANIM_THRESHOLD_2 ) {
      this.setState({
        animPhase2: 'gentle-first',
        animElapsed2: 0,
        gentleOrigin2: this.state.cloudx2,
      })
    } else {
      const newx = easeOutBack(newElapsed, this.CLOUD_START_2, this.state.cloud2Displ, this.ANIM_DURATION_2)
      this.setState({
        cloudx2: newx,
        animElapsed2: newElapsed,
      })
    }
  }


  gentleAnimFirstUpdate2() {
    let newElapsed = this.state.animElapsed2 + this.ANIM_UPDATE_INTERVAL

    if ( newElapsed >= this.ANIM_THRESHOLD_2 ) {
      this.setState({
        animPhase2: 'gentle',
        animElapsed2: 0,
        gentleOrigin2: this.state.cloudx2,
        gentleIncreasing2: true,
      })
    } else {
      let origin = this.state.gentleOrigin2
      const displacement = this.state.gentleIncreasing2 ? this.GENTLE_DISPLACEMENT_HALF_2 : - this.GENTLE_DISPLACEMENT_HALF_2
      let gi = this.state.gentleIncreasing2

      if ( newElapsed % this.GENTLE_DURATION_2 === 0 ) {
        gi = ! this.state.gentleIncreasing2
        origin = this.state.cloudx2
        newElapsed = 0
      }

      const newx =  easeOutQuint(newElapsed, origin, displacement, this.GENTLE_DURATION)

      this.setState({
        animElapsed2: newElapsed,
        cloudx2: newx,
        gentleOrigin2: origin,
        gentleDest2: newx,
        gentleIncreasing2: gi,
      })
    }
  }


  gentleAnimUpdate2() {
    let newElapsed = this.state.animElapsed2 + this.ANIM_UPDATE_INTERVAL

    let origin = this.state.gentleOrigin2
    const displacement = this.state.gentleIncreasing2 ? this.GENTLE_DISPLACEMENT_HALF_2 : - this.GENTLE_DISPLACEMENT_HALF_2
    let gi = this.state.gentleIncreasing2

    if ( newElapsed % this.GENTLE_DURATION_2 === 0 ) {
      gi = ! this.state.gentleIncreasing2
      origin = this.state.cloudx2
      newElapsed = 0
    }

    const newx = easeInOutSine(newElapsed, origin, displacement, this.GENTLE_DURATION_2)

    this.setState({
      animElapsed2: newElapsed,
      cloudx2: newx,
      gentleOrigin2: origin,
      gentleDest2: displacement,
      gentleIncreasing2: gi,
    })
  }


  initialAnimUpdate3() {
    const newElapsed = this.state.animElapsed3 + this.ANIM_UPDATE_INTERVAL

    if ( newElapsed >= this.ANIM_THRESHOLD_3 ) {
      this.setState({
        animPhase3: 'gentle-first',
        animElapsed3: 0,
        gentleOrigin3: this.state.cloudx3,
        gentleIncreasing3: true,
      })
    } else {
      const sub = easeOutBack(newElapsed, this.CLOUD_START_3, this.state.cloud3Displ, this.ANIM_DURATION_3)
      const newx = window.innerWidth - sub
      this.setState({
        cloudx3: newx,
        animElapsed3: newElapsed,
      })
    }
  }


  gentleAnimFirstUpdate3() {
    let newElapsed = this.state.animElapsed3 + this.ANIM_UPDATE_INTERVAL

    if ( newElapsed >= this.ANIM_THRESHOLD_3 ) {
      this.setState({
        animPhase3: 'gentle',
        animElapsed3: 0,
        gentleOrigin3: this.state.cloudx3,
        gentleIncreasing3: false,
      })
    } else {
      let origin = this.state.gentleOrigin3
      const displacement = this.state.gentleIncreasing3 ? this.GENTLE_DISPLACEMENT_HALF_3 : - this.GENTLE_DISPLACEMENT_HALF_3
      let gi = this.state.gentleIncreasing3
      let fg = this.state.firstGentleAnim3

      if ( newElapsed % this.GENTLE_DURATION_3 === 0 ) {
        gi = ! this.state.gentleIncreasing3
        origin = this.state.cloudx3
        newElapsed = 0
        fg = false
      }

      const newx = easeOutQuint(newElapsed, origin, displacement, this.GENTLE_DURATION_3)

      this.setState({
        animElapsed3: newElapsed,
        cloudx3: newx,
        gentleOrigin3: origin,
        gentleDest3: displacement,
        gentleIncreasing3: gi,
        firstGentleAnim3: fg,
      })
    }
  }


  gentleAnimUpdate3() {
    let newElapsed = this.state.animElapsed3 + this.ANIM_UPDATE_INTERVAL

    let origin = this.state.gentleOrigin3
    const displacement = this.state.gentleIncreasing3 ? this.GENTLE_DISPLACEMENT_HALF_3 : - this.GENTLE_DISPLACEMENT_HALF_3
    let gi = this.state.gentleIncreasing3

    if ( newElapsed % this.GENTLE_DURATION_3 === 0 ) {
      gi = ! this.state.gentleIncreasing3
      origin = this.state.cloudx3
      newElapsed = 0
    }

    const newx = easeInOutSine(newElapsed, origin, displacement, this.GENTLE_DURATION_3)

    this.setState({
      animElapsed3: newElapsed,
      cloudx3: newx,
      gentleOrigin3: origin,
      gentleDest3: displacement,
      gentleIncreasing3: gi,
    })
  }


  render() {
    const svgData1 = 'a 6 5 0 1 1 75,-50 a 8 4 0 1 1 75,10 a 6 5 0 1 1 -30,40 a 6 5 0 1 1 -80, 20 a 6 5 0 1 1 -35, -30'
    const svgData2 = 'a 6 5 0 1 1 75,-50 a 6 5 0 1 1 75,30 a 6 5 0 1 1 -30,40 a 6 5 0 1 1 -80, 20 a 6 5 0 1 1 -30, -50'
    const svgData3 = 'a 3 3 0 1 1 75,-10 a 6 5 0 1 1 -30,40 a 6 5 0 1 1 -50, 20 a 6 5 0 1 1 -20, -40 a 2 3 0 1 1 25 -15'

    const cloudLineWidth = 1.5
    //const whiteWithAlpha = 'rgba(255,255,255,0.75)'
    const whiteSolid = 'rgba(255,255,255, 1)'
    const blackWithAlpha = 'rgba(0,0,0,0.75)'

    //const fillColor = whiteWithAlpha
    const fillColor = whiteSolid
    const strokeColor = blackWithAlpha

    //const wordFontFamily = "UBahn Light"
    const wordFontFamily = "Geo Sans Light Oblique"

    const wordFontSize = 26
    const wordxpad = 42
    const wordypad = -28
    const wordx = this.state.cloudx + wordxpad
    const wordy = this.state.cloudy + wordypad
    const wordText = ''

    const word2FontSize = 28
    const word2xpad = 24
    const word2ypad = -18
    const word2x = this.state.cloudx2 + word2xpad
    const word2y = this.state.cloudy2 + word2ypad
    const word2Text = ''

    const word3FontSize = 24
    const word3xpad = -12
    const word3ypad = 0
    const word3x = this.state.cloudx3 + word3xpad
    const word3y = this.state.cloudy3 + word3ypad
    const word3Text = ''


    return (
      <Group>
        {/*
        <Path
          x={this.state.cloudx}
          y={this.state.cloudy}
          data={svgData1}
          fill={fillColor}
          stroke={strokeColor}
          strokeWidth={cloudLineWidth}
        />
        */}
        <Path
          x={this.state.cloudx3}
          y={this.state.cloudy3}
          data={svgData3}
          fill={fillColor}
          stroke={strokeColor}
          strokeWidth={cloudLineWidth}
        />
        {/*
        <Path
          x={this.state.cloudx2}
          y={this.state.cloudy2}
          data={svgData2}
          fill={fillColor}
          stroke={strokeColor}
          strokeWidth={cloudLineWidth}
        />
        */}
      </Group>
    )
  }
}
